import React from 'react';
import LazyLoad from 'react-lazyload';

const BoardApps = ({ icon, title, url, app_url }) => {
  return(
    <a href={ url ? app_url : url} target="_blank" rel="noopener noreferrer">
      <div className="empty">
        <LazyLoad height={100} offset={300}>
          <img src={icon} alt={title+ ", Pintripe"} />
        </LazyLoad>
      </div>
      <LazyLoad height={50} offset={300}>
        <h5 className="title">
          {title}
        </h5>
      </LazyLoad>
    </a>
  );
}

export default BoardApps;


// WEBPACK FOOTER //
// ./src/components/BoardApps.js